import { CustomEventNames, EventTypes } from './constants';

import { logRBIEvent } from './index';

type AddedToOrderIdentity = {
  engineId: string;
  sanityId: string;
  name: string;
};

type AddedToOrderContext = {
  redemptionMode: 'In-Store' | 'Online';
  distanceToStore?: number;
};

export const logRewardAddedToOrder = ({
  engineId,
  sanityId,
  name,
  redemptionMode,
  distanceToStore,
}: AddedToOrderIdentity & AddedToOrderContext): void => {
  logRBIEvent({
    name: CustomEventNames.REWARD_ADDED_TO_ORDER,
    type: EventTypes.Other,
    attributes: {
      engineId,
      sanityId,
      name,
      redemptionMode,
      distanceToStore,
    },
  });
};

export const logOfferAddedToOrder = ({
  engineId,
  sanityId,
  name,
  redemptionMode,
  distanceToStore,
  offerListPosition,
}: AddedToOrderIdentity &
  AddedToOrderContext & {
    offerListPosition: number | '';
  }): void => {
  logRBIEvent({
    name: CustomEventNames.OFFER_ADDED_TO_ORDER,
    type: EventTypes.Other,
    attributes: {
      engineId,
      sanityId,
      name,
      redemptionMode,
      distanceToStore,
      offerListPosition,
    },
  });
};
